/**
 * Image Search Agent - Tools Section
 *
 * Standard tools section with preamble and postamble from Keywords AI.
 */
import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { IMAGE_SEARCH_PROMPT_KEYS } from './variables';
// ═══════════════════════════════════════════════════════════════════════════
// TOOLS PREAMBLE
// ═══════════════════════════════════════════════════════════════════════════
class ImageSearchToolsPreambleSection extends PromptSectionBase {
    constructor() {
        super(...arguments);
        this.keywordsKey = IMAGE_SEARCH_PROMPT_KEYS.toolsPreamble;
        this.fallbackContent = `## Available Tools

You have access to multiple image search sources: Brandfetch (logos/brand), Wikimedia (general images), and presentation images.`;
    }
}
const toolsPreambleSection = new ImageSearchToolsPreambleSection();
export function getToolsPreamble() {
    return toolsPreambleSection.getContent();
}
// ═══════════════════════════════════════════════════════════════════════════
// TOOLS POSTAMBLE
// ═══════════════════════════════════════════════════════════════════════════
class ImageSearchToolsPostambleSection extends PromptSectionBase {
    constructor() {
        super(...arguments);
        this.keywordsKey = IMAGE_SEARCH_PROMPT_KEYS.toolsPostamble;
        this.fallbackContent = `**Workflow:**
1. Analyze each requirement to determine search order:
   - **Company logos**: Try in this order:
     1. Brandfetch (search_brandfetch → retrieve_brandfetch) - official brand assets
     2. Presentation search (if documentId provided) - check if logo exists locally
     3. Wikimedia (fallback) - if above sources don't have it
   - **Other media** (headshots, products, general images): Try in this order:
     1. Presentation search (if documentId provided) - check local assets first
     2. Wikimedia (search_wikimedia → retrieve_wikimedia)

2. For each requirement:
   a. Search sources in priority order until you find a match
   b. **FOR LOGOS**: Call retrieve_brandfetch ONCE - it automatically retrieves ALL available versions
      - Tool gets all available logo versions automatically
      - Use "logoOnly: true" for fast retrieval (default)
      - All versions shown as images for visual comparison
      - Then choose the best based on visual analysis
   c. **FOR OTHER IMAGES**: Select and retrieve the best match from search results
   d. Note the returned assetId(s)

3. After ALL requirements have assets retrieved, call submitResults`;
    }
}
const toolsPostambleSection = new ImageSearchToolsPostambleSection();
export function getToolsPostamble() {
    return toolsPostambleSection.getContent();
}
// ═══════════════════════════════════════════════════════════════════════════
// TOOLS SECTION BUILDER
// ═══════════════════════════════════════════════════════════════════════════
export function buildToolsSection(tools) {
    const parts = [];
    // 1. Preamble
    parts.push(getToolsPreamble());
    parts.push('');
    // 2. Individual tool descriptions
    for (const tool of tools) {
        parts.push(tool.systemPromptDescription);
        parts.push('');
    }
    // 3. Postamble
    parts.push(getToolsPostamble());
    return parts.join('\n');
}
